// Português do Brasil.
const ptBR = {
  "common.loading": "Carregando…",
  "common.back": "Voltar",
  "common.continue": "Continuar",
  "common.start": "Começar",
  "common.review": "Revisar",
  "common.watchAgain": "Assistir de novo",
  "common.read": "Ler",
  "common.understood": "Entendi",
  "common.retry": "Tentar de novo",
  "common.save": "Salvar",
  "common.saving": "Salvando…",
  "common.close": "Fechar",
  "common.demo": "Ambiente de demonstração · dados fictícios",
  "common.language": "Idioma",

  "nav.home": "Início",
  "nav.dashboard": "Painel",
  "nav.profile": "Perfil",
  "nav.certificates": "Meus certificados",
  "nav.logout": "Sair",
  "nav.openMenu": "Abrir menu",
  "nav.lesson": "Lição",
  "nav.learningWorlds": "Mundos de aprendizagem",
  "nav.controlPanel": "Painel de controle",
  "nav.badges": "Medalhas conquistadas",
  "nav.seeBadges": "Ver minhas medalhas",

  "login.title": "Entrar",
  "login.email": "E-mail",
  "login.password": "Senha",
  "login.submit": "Entrar",
  "login.noAccount": "Não tem conta?",
  "login.register": "Cadastre-se",
  "login.general": "Ir para o login geral",
  "login.orgNotFound": "Organização não encontrada",
  "login.error": "Não foi possível entrar. Verifique seu e-mail e senha.",
  "login.googleError": "Não foi possível entrar com o Google.",
  "login.goToOrg": "Ir para o login de {org}",
  "login.yourOrg": "sua organização",

  "home.welcome": "Bem-vindo à {org}",
  "home.noChallenges": "Você ainda não tem trilhas atribuídas.",
  "home.myChallenges": "Meus desafios",
  "home.pick": "Escolha uma trilha para começar sua experiência de aprendizagem.",
  "home.pickOrg": "{org}: escolha uma trilha para começar sua experiência de aprendizagem.",
  "home.loading": "Carregando dados…",
  "home.loadingHint": "Estamos preparando sua experiência de aprendizagem.",
  "home.loadingCourse": "Carregando curso…",
  "home.loadingCourseHint": "Estamos trazendo módulos, lições e progresso atualizado.",
  "home.loadingLessons": "Carregando lições…",
  "home.loadingLessonsHint": "Um momento, estamos organizando o mapa do curso.",
  "home.loadingChallenges": "Carregando cursos disponíveis…",
  "home.loadingChallengesHint": "Estamos buscando suas trilhas, progresso e ranking.",
  "home.courseError": "Não foi possível carregar o curso",
  "home.courseErrorHint": "Não foi possível carregar o curso. Verifique sua conexão e tente de novo.",
  "home.map": "Mapa de aprendizagem",
  "home.backToChallenges": "Voltar às trilhas",
  "home.overallProgress": "Progresso geral",
  "home.stages": "{done}/{total} módulos",
  "home.points": "pts",
  "home.lessons": "{done}/{total} lições",
  "home.stage": "Módulo",
  "home.locked": "Bloqueado",
  "home.completed": "Concluído",
  "home.inProgress": "Em andamento",
  "home.pending": "Pendente",
  "home.certifies": "Certifica",

  "task.startQuiz": "Começar avaliação",
  "task.startExercise": "Começar exercício",
  "task.startSimulation": "Começar simulação",
  "task.watch": "Assistir",
  "task.minutes": "{n} min",

  "lesson.backHome": "Voltar ao início",
  "lesson.backToMap": "Voltar ao mapa",
  "lesson.finishTitle": "Conclua esta lição",
  "lesson.finishHint": "Para avançar, primeiro salve seu progresso na lição atual.",
  "lesson.resourceOf": "Recurso {n} de {total}",
  "lesson.saved": "Seu progresso já foi salvo.",
  "lesson.saveWhenDone": "Quando terminar a atividade, salve seu progresso.",
  "lesson.saveWhenDoneLong": "Quando terminar a atividade, salve seu progresso para continuar.",
  "lesson.next": "Continue com o próximo recurso.",
  "lesson.nextLong": "Continue com o próximo recurso desta lição.",
  "lesson.nextResource": "Próximo recurso",
  "lesson.finish": "Concluir lição",
  "lesson.rate": "Avalie a lição",
  "lesson.rateHint": "Sua opinião nos ajuda a melhorar.",
  "lesson.loading": "Carregando lição",
  "lesson.congrats": "Parabéns!",
  "lesson.challengeDone": "Parabéns! Você concluiu a trilha!",
  "lesson.scormActive": "SCORM 1.2 ativo",

  "exam.title": "Avaliação",
  "exam.loading": "Carregando avaliação…",
  "exam.loadError": "Não foi possível carregar esta avaliação. Tente de novo.",
  "exam.sessionError": "Não foi possível carregar a avaliação: faltam dados de sessão ou trilha.",
  "exam.saveError": "Não foi possível salvar o resultado da avaliação.",
  "exam.passed": "Avaliação aprovada",
  "exam.saved": "Resultado salvo",
  "exam.score": "Você acertou {correct}/{total} ({pct}%).",
  "exam.needed": "Você precisa de pelo menos {n} respostas corretas para ser aprovado. Revise o conteúdo e tente de novo.",
  "exam.readyToSend": "Tudo pronto para enviar.",
  "exam.answerAll": "Responda todas as perguntas para enviar a avaliação.",
  "exam.submit": "Enviar avaliação",
  "exam.retry": "Tentar de novo",
  "exam.backToMap": "Voltar ao mapa",
  "exam.question": "Pergunta {n} de {total}",
  "exam.seeCertificate": "Ver meu certificado",
  "exam.passingScoreHint": "Aprovação com {n} respostas corretas de {total}.",

  "cert.title": "Certificado",
  "cert.certifies": "Certifica que",
  "cert.completed": "concluiu com êxito",
  "cert.issuedOn": "Emitido em {date}",
  "cert.validUntil": "Válido até {date}",
  "cert.code": "Código de verificação",
  "cert.score": "Nota: {pct}%",
  "cert.print": "Imprimir ou salvar PDF",
  "cert.mine": "Meus certificados",
  "cert.none": "Você ainda não tem certificados. Aprove uma avaliação certificável e ele aparecerá aqui.",
  "cert.view": "Ver certificado",
  "cert.verify": "Verificar em {url}",
  "cert.signedBy": "Assinatura",
  "cert.expired": "Vencido",
  "cert.valid": "Válido",
  "cert.expiring": "A vencer",

  "profile.myData": "Meus dados",
  "profile.organization": "Organização",
  "profile.badges": "Minhas medalhas",

  // Tema Aclara (Campus Aclara)
  "aclara.status.done": "Concluído",
  "aclara.status.progress": "Em andamento",
  "aclara.status.pending": "Pendente",
  "aclara.nav.route": "Minha trilha",
  "aclara.nav.news": "Notícias",
  "aclara.nav.certificates": "Certificados",
  "aclara.nav.dashboard": "Dashboard",
  "aclara.nav.profile": "Perfil",
  "aclara.role.admin": "Administração",
  "aclara.role.collaborator": "Colaborador/a",
  "aclara.footer.campus": "Campus de onboarding",
  "aclara.footer.powered": "Plataforma de aprendizagem Ewaffle",
  "aclara.login.eyebrow": "Onboarding",
  "aclara.login.claim": "Sua primeira semana na Aclara começa aqui.",
  "aclara.login.claimBody": "Seis módulos curtos para conhecer a empresa, como cuidamos das pessoas e do meio ambiente e como trabalhamos em equipe. Pelo celular e no seu idioma.",
  "aclara.login.metaModules": "módulos",
  "aclara.login.metaCountries": "países",
  "aclara.login.metaCerts": "certificados",
  "aclara.login.title": "Campus Aclara",
  "aclara.login.welcome": "Entre com seu e-mail corporativo.",
  "aclara.login.or": "ou",
  "aclara.home.eyebrow": "Campus",
  "aclara.home.hello": "Olá, {name}",
  "aclara.home.intro": "Sua trilha de onboarding: módulos curtos, duas avaliações certificáveis e um certificado ao concluir.",
  "aclara.home.seeRoute": "Ver minha trilha",
  "aclara.home.seeCertificates": "Ver meus certificados",
  "aclara.home.routeDone": "Trilha concluída",
  "aclara.home.routeDoneHint": "Você concluiu o onboarding. Seus certificados estão disponíveis.",
  "aclara.home.lessonsDone": "{done} de {total} lições",
  "aclara.home.nextIs": "Próxima: {name}",
  "aclara.home.loadingRoute": "Carregando sua trilha…",
  "aclara.home.modulesEyebrow": "Sua trilha",
  "aclara.home.newsTitle": "Últimas da Aclara",
  "aclara.home.allNews": "Todas as notícias",
  "aclara.home.allCerts": "Ver todos",
  "aclara.news.eyebrow": "Notícia",
  "aclara.news.title": "Notícias",
  "aclara.news.intro": "Novidades da empresa e de cada país. O que a equipe de Pessoas publica aparece aqui.",
  "aclara.news.none": "Ainda não há notícias publicadas.",
  "aclara.module.lessonsCount": "{done}/{total} lições",
  "aclara.module.certifies": "Certifica",
  "aclara.module.n": "Módulo {n}",
  "aclara.module.notFound": "Não encontramos este módulo na sua trilha.",
  "aclara.module.contents": "Conteúdo do módulo",
  "aclara.module.certHint": "Ao ser aprovado em «{title}» você recebe um certificado válido por 12 meses. Pode repetir a avaliação quantas vezes precisar.",
  "aclara.lesson.kindLesson": "Lição",
  "aclara.lesson.kindExam": "Avaliação",
  "aclara.lesson.notFound": "Não encontramos esta lição na sua trilha.",
  "aclara.lesson.noResource": "Esta lição ainda não tem conteúdo carregado.",
  "aclara.lesson.status": "Status",
  "aclara.lesson.scormHint": "O progresso é registrado ao terminar o conteúdo. Se você já revisou tudo, marque aqui.",
  "aclara.lesson.markDone": "Marcar como concluída",
  "aclara.lesson.adminPreview": "Visualização de administração: o progresso só é registrado para colaboradores.",
  "aclara.lesson.prev": "Anterior",
  "aclara.lesson.next": "Próxima",
  "aclara.lesson.module": "Ver módulo",
  "aclara.exam.notYet": "Ainda não",
  "aclara.exam.backToRoute": "Voltar à minha trilha",
  "aclara.certs.intro": "Os certificados que você obtém ao ser aprovado em uma avaliação. Cada um tem um código que qualquer pessoa pode verificar.",
  "aclara.profile.noBadges": "Você ainda não tem medalhas. Conclua sua primeira lição para ganhar a primeira.",
  "aclara.dash.openAdmin": "Abrir ferramentas de administração",
  "aclara.dash.title": "Progresso por {label}",
  "aclara.dash.intro": "Quantas pessoas estão inscritas, quantas concluíram a trilha e quantos certificados foram emitidos, por país.",
  "aclara.dash.noSegment": "Sem {label}",
  "aclara.dash.kpiTotal": "Pessoas",
  "aclara.dash.kpiEnrolled": "Inscritas",
  "aclara.dash.kpiDone": "Concluíram",
  "aclara.dash.kpiCerts": "Certificados",
  "aclara.dash.bySegment": "Resumo por {label}",
  "aclara.dash.empty": "Ainda não há dados para mostrar.",
  "aclara.dash.completion": "Concluíram / inscritas",
  "aclara.dash.progressBy": "Progresso da trilha por {label}",
  "aclara.dash.bucket.done": "Concluíram",
  "aclara.dash.bucket.mid": "Em andamento",
  "aclara.dash.bucket.none": "Não iniciaram",
  "aclara.dash.people": "{n} pessoas",
  "aclara.dash.avgProgress": "Progresso médio",
  "aclara.dash.avgGrade": "Nota média",
  "aclara.dash.loggedIn": "Já acessaram",
};

export default ptBR;
